import createVueApp from '@phoenix/createVueApp';

import PhxsgInfoBlock from './phxsg-info-block.vue';

document.querySelectorAll('[data-component="phxsg-info-block"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgInfoBlock', PhxsgInfoBlock);
  app.mount(el);
});
